import { writable, derived } from 'svelte/store'
import config from './config.js'
import { currencies } from './data/coins.js'
export { liveFxRates } from './utils/pollStore.js'

function createCounter () {
	const { subscribe, set, update } = writable(0)

	return {
		subscribe,
		set,
		add: (x) => update(n => n + x),
		subtract: (x) => update(n => n - x),
		increment: () => update(n => n + 1),
		decrement: () => update(n => n - 1),
		reset: () => set(0)
	}
}

function createCachedDict (namespace, defaultValues) {
	const initial = {
		...defaultValues
	}

	// load from local storage
	Object.keys(initial).forEach(field => {
		const val = localStorage.getItem(`${namespace}-${field}`)
		if (val != null) initial[field] = JSON.parse(val)
	})

	const { subscribe, set, update } = writable(initial)

	return {
		subscribe,
		set: (val) => {
			set(val)
			Object.keys(val).forEach(field => {
				localStorage.setItem(`${namespace}-${field}`, val[field])
			})
		}
	}
}

const urlCurrencyCode = window.location.pathname.split('/')[1].trim('#')
export const selectedCurrencyCode = writable(currencies[urlCurrencyCode] ? urlCurrencyCode : 'USD')

export const darkMode = writable(true)

export const settingsOpen = writable(false)

export const settings = createCachedDict('settings', {
	darkMode: true,
	showMessages: true,
	noTrack: false
})

export const sidebarToggle = writable(null)
export const flipToggle = writable(false)

export const overlay = writable(null)

export const alerts = writable([
  { "type": "mononaut", "key": "by-mononaut", "action": "contact" },
  { "type": "msg", "key": "bitfeed", "msg": "While you're here,<br>check out Bitfeed", "shortmsg": "Check out Bitfeed", "href": "https://bits.monospace.live", "img": "https://bits.monospace.live/img/bitfeed-logo.svg" },
  { "type": "msg", "key": "donate", "msg": "Coin Bits is funded by the community.<br>Click here to make a small donation!", "shortmsg": "Tap here to support the project!", "action": "support" }
])
